@use 'shared/styles/generated/tokens' as *;
@use 'shared/styles/mixins' as *;

.root {
  flex: none;
  display: block;
  object-fit: contain;
}

.hasGlow {
  filter: $shadow-mascot;
}
